import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from "../../gameData.js";

export default class Facemask extends AContainer
{
    constructor(scene)
    {
        super(scene);

        this.scene = scene;
        this.loc = {x:this.scene.mid.x + 143, y:this.scene.mid.y + 26};
        this.faces = [];
        this.patterns = [];

        this.createMask();
        this.createMasker();
        this.createFace();
        this.createPattern();
        this.createPaint();
        //this.createExploder();

        this.setPosition(this.loc.x, this.loc.y);
        this.scene.addToParent(this, this.scene);
    }

    createMask()
    {
        this.bg = this.scene.addImage(this.loc.x, this.loc.y, "Mask_Main");
        this.rt = this.scene.add.renderTexture(0, 0, this.scene.mid.x*2, this.scene.mid.y*2);
        this.bgShadow = this.scene.addImage(this.loc.x, this.loc.y, "Mask_Main_Shadow");
        this.trim = this.scene.addImage(this.loc.x, this.loc.y - 26, "Mask_Trim");
        this.trimShadow = this.scene.addImage(this.loc.x, this.loc.y - 26, "Mask_Trim_Shadow");
        
        if(gameData.bgColor === null) this.bg.tint = gameData.bgColor = gameData.dotColors[11];
        else this.bg.tint = gameData.bgColor;

        if(gameData.trimColor === null) this.trim.tint = gameData.trimColor = gameData.dotColors[10];
        else this.trim.tint = gameData.trimColor;

        this.bg.setDepth(5);
        this.setDepth(6);
        this.rt.setDepth(7);
        this.bgShadow.setDepth(10);
        this.trim.setDepth(15);
        this.trimShadow.setDepth(15);

        this.bgShadow.blendMode = Phaser.BlendModes.MULTIPLY;
        this.trimShadow.blendMode = Phaser.BlendModes.MULTIPLY;
    }

    createMasker()
    {
        let points = 
                [this.loc.x - this.bg.width/2 + 2, this.loc.y - this.bg.height/2 + 30, 
                this.loc.x - this.bg.width/2 + 250, this.loc.y - this.bg.height/2, 
                this.loc.x - this.bg.width/2 + 490, this.loc.y - this.bg.height/2 + 30,
                this.loc.x - this.bg.width/2 + 460, this.loc.y - this.bg.height/2 + 270,
                this.loc.x - this.bg.width/2 + 350, this.loc.y - this.bg.height/2 + 345,
                this.loc.x - this.bg.width/2 + 250, this.loc.y - this.bg.height/2 + 370,
                this.loc.x - this.bg.width/2 + 130, this.loc.y - this.bg.height/2 + 340,
                this.loc.x - this.bg.width/2 + 27, this.loc.y - this.bg.height/2 + 265];
        this.masker = this.scene.addPolygon(0, 0, points, 0xff0000);

        this.mask = new Phaser.Display.Masks.GeometryMask(this.scene, this.masker);
        this.rt.mask = new Phaser.Display.Masks.GeometryMask(this.scene, this.masker);

        this.maskRef = new Phaser.Geom.Polygon(points);
    }

    createFace()
    {
        for(let i=1;i<=6;i++){
            let face = this.scene.addImage(this.loc.x, this.loc.y, "Face"+i);
            face.visible = false;
            face.setDepth(6);
            this.faces.push(face);
        }
    }

    createPattern()
    {
        for(let i=1;i<=6;i++){
            let pattern = this.scene.addImage(this.loc.x, this.loc.y, "Pattern"+i);
            pattern.visible = false;
            pattern.setDepth(6);
            this.patterns.push(pattern);
        }
    }

    createPaint()
    {
        this.setPaintColor();

        this.scene.input.on('pointermove', (pointer) => {
            if (!gameData.gamePaused && pointer.isDown && gameData.gameMode == 6 &&  !gameData.isDragging && this.maskRef.contains(pointer.x, pointer.y) && !gameData.popupOpen){
                this.DrawErase(pointer, this.rt, this.paintBrush, gameData.isErasing);
            }
        }, this);
    }

    DrawErase(pointer, RenderTexture, ShapeToDraw, setErase = false)
    {
        var points;
        var DrawLog;
        var interpVal = Math.min(1, (pointer.getDistance() / 500));
        var interpNum = Math.round(interpVal * 250);

        points = pointer.getInterpolatedPosition(interpNum);
        for(let x in points)
        {
            setErase ? DrawLog = RenderTexture.erase(ShapeToDraw, points[x].x-RenderTexture.x, points[x].y-RenderTexture.y) : DrawLog = RenderTexture.draw(ShapeToDraw, points[x].x-RenderTexture.x, points[x].y-RenderTexture.y);
        }
        return DrawLog;
    }

    setPaintColor()
    {
        if(this.paintBrush) this.paintBrush.destroy();
        this.paintBrush = this.scene.addCirc(0, 0, (5 * (4-gameData.brushSize)), gameData.paintColor);
        this.paintBrush.visible = false;
    }

    clearPaint()
    {
        if(this.paintBrush) this.paintBrush.destroy();
        gameData.brushSize = 1;
        gameData.paintColor = "0xf2f0e7";
        gameData.isErasing = false;

        this.rt.clear();
    }

    setFace(id = null)
    {
        for(let i=0;i<this.faces.length;i++){
            this.faces[i].visible = false;
        }

        gameData.faceActive = false;

        if(id != null) {
            this.faces[id].visible = true;
            gameData.faceActive = true;
        }
    }

    setPattern(id = null)
    {
        for(let i=0;i<this.patterns.length;i++){
            this.patterns[i].visible = false;
        }

        gameData.patternActive = false;

        if(id != null) {
            this.patterns[id].visible = true;
            gameData.patternActive = true;
        }
    }

    setMasker(img)
    {
        img.mask = this.masker;
    }

    tintMask(tint, type)
    {
       
        if(type === "mask") {
            this.bg.tint = tint;
            gameData.bgColor = tint;
        }
        if(type === "trim") {
            this.trim.tint = tint;
            gameData.trimColor = tint;
        }
        if(type === "all") {
            this.bg.tint = tint;
            this.trim.tint = "0x4c4b48";
            gameData.bgColor = null;
            gameData.trimColor = null;
        }
    }

    createExploder(texture, colors, pos)
    {
        //console.log("exploding", this.scene.defaultAtlas);
        this.explodeEmitter = this.scene.addEmitter({
            //x: this.scene.mid.x, y: this.scene.mid.y,
            tint: colors,
            scale: {min: .1, max: .25},
            rotate: {min: 0,  max: 360},
            gravityY: 600,
            speedY: {min: -300, max: 100},
            speedX: {min: -200, max: 200},
            lifespan: {min: 4000, max: 6000},
        }, texture, this.scene.defaultAtlas);
        this.explodeEmitter.fadeInOut(1, Phaser.Math.Easing.Sine.Out);
        this.explodeEmitter.explode(15, pos.x, pos.y);
        this.scene.addToParent(this.explodeEmitter.manager, this);
        //this.explodeEmitter.manager.setDepth(500);
    }

    tweenInMask()
    {
        this.scene.addTween(this, 500, {x:this.scene.mid.x, y:this.scene.mid.y}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.masker, 500, {x:-143, y:-25}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.bg, 500, {x:this.scene.mid.x, y:this.scene.mid.y}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.rt, 500, {x:this.scene.mid.x-this.loc.x, y:this.scene.mid.y-this.loc.y}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.bgShadow, 500, {x:this.scene.mid.x, y:this.scene.mid.y}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.trim, 500, {x:this.scene.mid.x, y:this.scene.mid.y - 26}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.trimShadow, 500, {x:this.scene.mid.x, y:this.scene.mid.y - 26}, Phaser.Math.Easing.Quadratic.Out);

        this.faces.forEach((face) => {
            this.scene.addTween(face, 500, {x:this.scene.mid.x, y:this.scene.mid.y}, Phaser.Math.Easing.Quadratic.Out);
        });
        this.patterns.forEach((pattern) => {
            this.scene.addTween(pattern, 500, {x:this.scene.mid.x, y:this.scene.mid.y}, Phaser.Math.Easing.Quadratic.Out);
        });
    }

    tweenOutMask()
    {
        this.scene.addTween(this, 500, {x:this.loc.x, y:this.loc.y}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.masker, 500, {x:0, y:0}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.bg, 500, {x:this.loc.x, y:this.loc.y}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.rt, 500, {x:0, y:0}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.bgShadow, 500, {x:this.loc.x, y:this.loc.y}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.trim, 500, {x:this.loc.x, y:this.loc.y - 26}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.trimShadow, 500, {x:this.loc.x, y:this.loc.y - 26}, Phaser.Math.Easing.Quadratic.Out);

        this.faces.forEach((face) => {
            this.scene.addTween(face, 500, {x:this.loc.x, y:this.loc.y}, Phaser.Math.Easing.Quadratic.Out);
        });
        this.patterns.forEach((pattern) => {
            this.scene.addTween(pattern, 500, {x:this.loc.x, y:this.loc.y}, Phaser.Math.Easing.Quadratic.Out);
        });
    }

    cleanUp()
    {
        this.bg.destroy();
        this.trim.destroy();
        this.trimShadow.destroy();
        this.bgShadow.destroy();
        this.masker.destroy();
    }
}